import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from 'react-i18next';
import ISONumber from "components/formatting/ISONumber";

interface SubqueriesPortionTooltipProps {
  rowVolume: number;
  rootVolume: number;
  volumeField: string;
}

export default function SubqueriesPortionTooltip(props: SubqueriesPortionTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const { rowVolume, rootVolume, volumeField }: SubqueriesPortionTooltipProps = props;

  return (
    <Box>
      <Typography variant="h4" sx={{ textAlign: "center", fontWeight: "bold", mb:1 }}>
        {i18n.t(volumeField)}
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: "auto auto", gap: 1, textAlign: "right" }}>
        <Box>{i18n.t("widget-types.subqueries.subquery")}</Box>
        <Box>
          <ISONumber number={rowVolume}  sx={{ fontWeight: "bold", color: theme.palette.primary.main }}/>
        </Box>
        <Box>{i18n.t("widget-types.subqueries.original")}</Box>
        <Box>
          <ISONumber number={rootVolume} sx={{ fontWeight: "bold", color: theme.palette.primary.main }}/>
        </Box>
      </Box>
    </Box>
  );
}
